package com.wintermar.inspection.feature.presentation.inspection.answer.widget

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.withStyle
import com.wintermar.inspection.core.ui.component.LinkText
import com.wintermar.inspection.core.ui.component.TextBodyRegular
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.util.highlightKeyword
import com.wintermar.inspection.feature.domain.model.template.InspectionTemplateQuestionModel
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.ic_arrow_right

@Composable
fun ContentItemQuestion(
    item: InspectionTemplateQuestionModel,
    keyword: String = "",
    showLinkQuestion: Boolean = false,
    dimension: AppDimension = LocalAppTheme.current.dimension,
    onShowModalGuidance: () -> Unit,
    onGoToQuestion: () -> Unit = {}
) {
    Column(
        verticalArrangement = Arrangement.spacedBy(dimension.spacing.space2)
    ) {
        TextBodyRegular(
            annotatedString = buildAnnotatedString {
                val text = item.questionText.trim()
                val highlightedText = text.highlightKeyword(keyword)
                append(highlightedText)
                if (item.required) {
                    val mandatoryStyle =
                        LocalAppTheme.current.textStyle.body.regular.toSpanStyle()
                            .copy(
                                color = LocalAppTheme.current.color.surface.accent.red.bold.default,
                                fontWeight = FontWeight.Bold
                            )
                    withStyle(style = mandatoryStyle) {
                        append(" *")
                    }
                }
            },
            bold = true
        )

        Row(
            horizontalArrangement = Arrangement.spacedBy(dimension.spacing.space2),
            verticalAlignment = Alignment.CenterVertically
        ) {
            if (item.guidelines.isNotEmpty()) {
                LinkText(
                    text = "View guidance",
                    icon = Res.drawable.ic_arrow_right,
                    bold = true,
                    onClick = {
                        onShowModalGuidance()
                    }
                )
            }

            if (showLinkQuestion) {
                LinkText(
                    text = "Go to question",
                    icon = Res.drawable.ic_arrow_right,
                    bold = true,
                    onClick = {
                        onGoToQuestion()
                    }
                )
            }
        }
    }
}
